import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { decryptUrlDatapattern, encryptUrlDatapattern } from "../../../../components/commonClass/EncFunc";
import { getPassengerType } from "../../../../components/commonClass/CommonValidation";
import { loaderActions } from "../../../../_actions/loader.actions";
import { postUsersData, verifytoken } from "../../../../services/ApiCallingUserServices";
import { ClearLocalStorage, GetLocalStorage } from "../../../../components/commonClass/Session";
import FlightReviewComponant from "../partial/FlightReviewComponant";
import flightIcon from '../../../../assets/img/flights/Icone/flightIcon.svg';
import SeatBooking from "./SeatBooking";
import PriceSummary from "../../DetailScreen/partial/PriceSummary";
import { getPriceSummaryDetails } from "../../../../components/commonClass/CommonFunctions";
import { Modal } from "react-bootstrap";

const FlightPayment = (props: any) => {
    const { flightFareQouteData, flightFareRuleData, passengersData, otherData, flightSsrData, markupAndConvenienceDetail, isDomRtn, UpdatedBookFlightData, onFlightDataUpdate } = props;

    const isinternationalData = sessionStorage.getItem('isinternational');
    const isInternational = isinternationalData ? JSON.parse(isinternationalData) : false;

    const paramsForBaggage = useMemo(() => {
        return {
            isLCC: flightFareQouteData?.[isDomRtn]?.response?.results?.isLCC || false,
            airlineCode: flightFareQouteData?.[isDomRtn]?.response?.results?.airlineCode || "",
            journeyTypeId: flightFareQouteData?.[isDomRtn]?.response?.journeyTypeId || 0
        }
    }, [flightFareQouteData, isDomRtn]);
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedFlight, setSelectedFlight] = useState('');
    const [selectedFlightPassenger, setSelectedFlightPassenger] = useState('');
    const [mealDynamicCollection, setMealDynamicCollection] = useState<any>([]);
    const [seatDynamicCollection, setSeatDynamicCollection] = useState<any>([]);
    const [baggageCollection, setBaggageCollection] = useState<any>([]);

    const [isMealDropdownOpen, setIsMealDropdownOpen] = useState(false);
    const [isBaggageDropdownOpen, setIsBaggageDropdownOpen] = useState(false);

    const [showPriceTimeUpdatedModal, setShowPriceTimeUpdatedModal] = useState(false);
    const messagePriceTimeUpdate = "Please check price & time update before proceeding for payment";

    var razorpopup = document.getElementsByClassName('razorpay-container');
    const location = useLocation();
    const APIBadMessage = 'Something went wrong, Please try again!'

    const newSearchParams = useMemo(() => {
        return new URLSearchParams(searchParams);
    }, [searchParams])

    const getbookingid = useMemo(() => {
        return decryptUrlDatapattern(location?.state?.BookingId)?.[isDomRtn]
    }, [location, isDomRtn])

    //#region set passengers and others data
    const passengersDetailsData = useMemo(() => {
        const passengersData = sessionStorage.getItem('passengers');
        const passengersSessionData = passengersData ? JSON.parse(passengersData) : [];
        return passengersSessionData ? passengersSessionData : passengersData;
    }, [passengersData])

    const othersDetailsData = useMemo(() => {
        const othersData = sessionStorage.getItem('others');
        const othersSessionData = othersData ? JSON.parse(othersData) : [];
        return othersSessionData ? othersSessionData : otherData;
    }, [otherData])

    const allPaxTypesWithIds = useMemo(() => {
        const adultPaxAll = passengersDetailsData?.filter((item: any) => item?.PaxType === 1).reduce((acc: any, curr: any) => acc = [...acc, `${curr?.PaxType}${curr?.id}`], []);
        const childPaxAll = passengersDetailsData?.filter((item: any) => item?.PaxType === 2).reduce((acc: any, curr: any) => acc = [...acc, `${curr?.PaxType}${curr?.id}`], []);

        return { adultPaxAll: adultPaxAll || [], childPaxAll: childPaxAll || [] }

    }, [passengersDetailsData])

    //#endregion

    //#region get passengers counts
    const passangerCounts = useMemo(() => {
        const adultCount = flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.find((fin: any) => fin?.passengerType === 1)?.passengerCount || 0;
        const childCount = flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.find((fin: any) => fin?.passengerType === 2)?.passengerCount || 0;
        const infantCount = flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.find((fin: any) => fin?.passengerType === 3)?.passengerCount || 0;
        return { adultCount: adultCount, childCount: childCount, infantCount: infantCount, total: adultCount + childCount + infantCount }
    }, [flightFareQouteData?.[isDomRtn]])
    //#endregion


    const flightCollection = useMemo(() => {
        let flightData: any[] = [];
        flightFareQouteData?.[isDomRtn]?.response?.results?.segments?.map((seg: any, ind: any) => {
            let flightSeg = seg?.reduce((acc: any, curr: any, index: any, arr: any) => {
                acc.push({
                    flightName: `${curr.origin?.airport?.cityName} to ${curr.destination?.airport?.cityName}`,
                    flightNameTemp: `${curr.origin?.airport?.cityName}${curr.destination?.airport?.cityName}`,
                    flightNumber: curr?.airline?.flightNumber
                })
                return acc;
            }, []);
            flightData = [...flightData, ...flightSeg];
        });
        setSelectedFlight(`flight1${flightData[0]?.flightNumber}`)
        setSelectedFlightPassenger(`flight1${flightData[0]?.flightNumber}Adult1`)
        setIsMealDropdownOpen(false);
        setIsBaggageDropdownOpen(false);
        return flightData;

    }, [flightFareQouteData?.[isDomRtn]])

    const selectedSeatMealDynamicValidation = useMemo(() => {
        let seatcheck = false
        let mealcheck = false
        if (passengersDetailsData?.length > 0 && seatDynamicCollection?.length > 0 && flightCollection?.length > 0) {
            seatcheck = flightCollection?.every((_, index) =>
                passengersDetailsData?.filter((el: any) => el.PaxType < 3)?.every((ele: any) =>
                    seatDynamicCollection?.[index]?.rowSeats?.some((rowSeat: any) =>
                        rowSeat?.seats?.some(
                            (seat: any) => seat?.paxType === `${ele?.PaxType}${ele?.id}`
                        )
                    )
                )
            );
        }
        mealcheck = flightCollection?.every((el) =>
            passengersDetailsData?.filter((el: any) => el.PaxType < 3)?.every((ele: any) =>
                mealDynamicCollection?.filter((ele: any) => ele.flightNumber === el?.flightNumber)?.some(
                    (meal: any) => meal?.paxType?.includes(`${ele?.PaxType}${ele?.id}`)
                )
            )
        );
        return { seatcheck, mealcheck }
    }, [passengersDetailsData, seatDynamicCollection, flightCollection, mealDynamicCollection])


    const requiredFieldValidators = useMemo(() => {
        let required = { isMealRequired: false, isSeatRequired: false };
        if (flightFareQouteData && flightFareQouteData?.length > 0) {
            required = {
                isMealRequired: flightFareQouteData?.[0]?.response?.results?.requiredFieldValidators ? flightFareQouteData?.[0]?.response?.results?.requiredFieldValidators?.isMealRequired : false,
                isSeatRequired: flightFareQouteData?.[0]?.response?.results?.requiredFieldValidators ? flightFareQouteData?.[0]?.response?.results?.requiredFieldValidators?.isSeatRequired : false
            }
        }
        return required

    }, [flightFareQouteData])

    //#region in passanger list set seat, meal and baggage
    const getPassangersData = (isSkipToPay: boolean) => {
        return passengersDetailsData?.map((pass: any) => {
            pass.MealDynamic = [];
            pass.Baggage = [];
            pass.SeatDynamic = [];
            mealDynamicCollection?.filter((fil: any) => fil?.paxType?.length > 0 && (isSkipToPay ? fil?.IsMealValidate === true : true))?.forEach((meal: any) => {
                if (meal?.paxType?.includes(`${pass?.PaxType}${pass?.id}`)) {
                    pass.MealDynamic = [...pass.MealDynamic, meal]
                }
            })
            baggageCollection?.filter((fil: any) => fil?.paxType?.length > 0 && (isSkipToPay ? fil?.IsBaggageValidate === true : true))?.forEach((bag: any) => {
                if (bag?.paxType?.includes(`${pass?.PaxType}${pass?.id}`)) {
                    pass.Baggage = [...pass.Baggage, bag]
                }
            })
            seatDynamicCollection?.map((seatDynamic: any) => {
                seatDynamic?.rowSeats?.filter((rowSeat: any) => {
                    rowSeat?.seats?.filter((fil: any) => fil?.paxType?.trim()?.length > 0)?.forEach((seat: any) => {
                        if (seat?.paxType === `${pass?.PaxType}${pass?.id}`) {
                            pass.SeatDynamic = [...pass.SeatDynamic, seat]
                        }
                    })
                })
            })

            return pass;
        })
    }
    //#endregion


    const handleChangeFlight = (flight: any, flightIndex: any) => {
        setSelectedFlight(`flight${flightIndex + 1}${flight?.flightNumber}`);
        setSelectedFlightPassenger(`flight${flightIndex + 1}${flight?.flightNumber}Adult1`);
        setIsMealDropdownOpen(false);
        setIsBaggageDropdownOpen(false);
    }
    const handleChangeFlightPassenger = (flight: any, flightIndex: any, pass: any) => {
        setSelectedFlightPassenger(`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}`);
        setIsMealDropdownOpen(false);
        setIsBaggageDropdownOpen(false);
    }

    const handleMealDropdownOpen = (e: any) => {
        e.stopPropagation(); // Prevents event from bubbling to outer div
        setIsMealDropdownOpen(!isMealDropdownOpen);
    }
    const handleBaggageDropdownOpen = (e: any) => {
        e.stopPropagation(); // Prevents event from bubbling to outer div
        setIsBaggageDropdownOpen(!isBaggageDropdownOpen);
    }

    //#region convenience fee calculation
    const convenienceData = useMemo(() => {
        let convinienceFeeCharged = 0;
        if (markupAndConvenienceDetail?.[0]?.isConvinienceFee && flightFareQouteData?.[isDomRtn]?.response?.results?.fare?.isMarkupApply) {
            if (!markupAndConvenienceDetail?.[0]?.isConvinienceFeePercentage) {
                convinienceFeeCharged = Math.round((markupAndConvenienceDetail?.[0]?.convenienceFeesWeb + (markupAndConvenienceDetail?.[0]?.convenienceFeesWeb * 18 / 100)) * passangerCounts.total);
            }
            else {
                convinienceFeeCharged = Math.round(
                    (flightFareQouteData?.[isDomRtn]?.response?.results?.fare?.grandTotal * markupAndConvenienceDetail?.[0]?.convenienceFeesWeb / 100)
                    + (
                        (flightFareQouteData?.[isDomRtn]?.response?.results?.fare?.grandTotal * markupAndConvenienceDetail?.[0]?.convenienceFeesWeb / 100)
                        * 18 / 100));
            }
        }

        return { convinienceFeeCharged: convinienceFeeCharged }

    }, [markupAndConvenienceDetail, passangerCounts])
    //#endregion

    //#region set baggage, meal and seat data in state
    useEffect(() => {
        let baggages = flightSsrData?.response?.baggage?.reduce((acc: any, curr: any) => {
            curr?.map((obj: any) => acc = [...acc, obj])
            return acc;
        }, [])
        let meals = flightSsrData?.response?.mealDynamic?.reduce((acc: any, curr: any) => {
            curr?.map((obj: any) => acc = [...acc, obj])
            return acc;
        }, [])
        const seats = flightSsrData?.response?.seatDynamic?.reduce((acc: any, curr: any) => {
            curr?.segmentSeat?.map((obj: any) => acc = [...acc, obj])
            return acc;
        }, [])


        const airlineCodeBaggageMealatZero = ["I5"];

        const condition1 = isInternational && paramsForBaggage?.isLCC;
        const condition2 = airlineCodeBaggageMealatZero?.includes(paramsForBaggage?.airlineCode) && !isInternational;
        const condition3 = paramsForBaggage?.journeyTypeId === 2;

        if (condition1) {
            baggages?.map((bag: any) => {
                const checkCondition = bag?.price === 0;

                if (checkCondition) {
                    bag.paxType = [...allPaxTypesWithIds?.adultPaxAll, ...allPaxTypesWithIds?.childPaxAll];
                    bag.IsBaggageValidate = true;
                }
                return bag;
            })
        }

        if (condition2) {
            baggages?.map((bag: any) => {
                const checkCondition = bag?.price === 0;

                if (checkCondition) {
                    bag.paxType = [...allPaxTypesWithIds?.adultPaxAll, ...allPaxTypesWithIds?.childPaxAll];
                    bag.IsBaggageValidate = true;
                }
                return bag;
            })

            meals?.map((meal: any) => {
                const checkCondition = meal?.price === 0;

                if (checkCondition) {
                    meal.paxType = [...allPaxTypesWithIds?.adultPaxAll, ...allPaxTypesWithIds?.childPaxAll];
                    meal.IsMealValidate = true;
                }
                return meal;
            })
        }

        if (condition3) {
            baggages?.map((bag: any) => {
                const checkCondition = bag?.price === 0;

                if (checkCondition) {
                    bag.paxType = [...allPaxTypesWithIds?.adultPaxAll, ...allPaxTypesWithIds?.childPaxAll];
                    bag.IsBaggageValidate = true;
                }
                return bag;
            })
        }

        if (!condition1 && !condition2 && !condition3) {
            baggages?.map((bag: any) => {
                const checkCondition = bag?.price === 0;

                if (checkCondition) {
                    bag.paxType = [];
                    bag.IsBaggageValidate = false;
                }
                return bag;
            })

            meals?.map((meal: any) => {
                const checkCondition = meal?.price === 0;
                if (checkCondition) {
                    meal.paxType = [];
                    meal.IsMealValidate = true;
                }
                return meal;
            })
        }

        setBaggageCollection(baggages || []);
        setMealDynamicCollection(meals || []);
        setSeatDynamicCollection(seats || []);
    }, [flightSsrData, isInternational, passengersDetailsData, allPaxTypesWithIds, paramsForBaggage]);
    //#endregion

    //#region get selected seat, meal and baggage total price
    const selectedMealDynamicTotalPrice = useMemo(() => {
        return mealDynamicCollection?.filter((fil: any) => fil?.paxType?.length > 0)?.length > 0 ?
            mealDynamicCollection?.filter((fil: any) => fil?.paxType?.length > 0)?.reduce((acc: any, curr: any, index: any, arr: any) => {
                acc += (curr?.price * curr?.paxType?.length);
                return acc;
            }, 0)
            :
            null
    }, [mealDynamicCollection])

    const selectedBaggageTotalPrice = useMemo(() => {
        return baggageCollection?.filter((fil: any) => fil?.paxType?.length > 0)?.length > 0 ?
            baggageCollection?.filter((fil: any) => fil?.paxType?.length > 0)?.reduce((acc: any, curr: any, index: any, arr: any) => {
                acc += (curr?.price * curr?.paxType?.length);
                return acc;
            }, 0)
            :
            null
    }, [baggageCollection])

    const selectedSeatTotalPrice = useMemo(() => {
        let seatPrice: any = null
        seatDynamicCollection?.map((seatDynamic: any) => {
            seatDynamic?.rowSeats?.filter((rowSeat: any) => {
                rowSeat?.seats?.filter((fil: any) => fil?.paxType?.trim()?.length > 0) ?
                    rowSeat?.seats?.filter((fil: any) => fil?.paxType?.trim()?.length > 0)?.reduce((acc: any, curr: any, index: any, arr: any) => {
                        seatPrice += curr?.price;
                        acc += curr?.price;
                        return acc;
                    }, 0)
                    :
                    seatPrice = null;
            })
        })
        return seatPrice;
    }, [seatDynamicCollection])
    //#endregion

    //#region lead passenger Data
    const leadPassengerData = useMemo(() => passengersDetailsData?.find((fin: any) => fin?.IsLeadPax === true), [passengersDetailsData])
    //#endregion

    //#region fetch end user IP
    const fetchIp = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return {
                status: true,
                data: data?.ip
            }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return {
                status: false,
                data: null
            }
        }
    };
    //#endregion

    //#region call TBO's flight booking and ticket booking APIs
    const bookingLCCnonLCCFlight = async (passangerDetails: any, razorpayresponsedata: any, isSkipToPay: any, bookFlightData: any) => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            let userip = await fetchIp();
            if (userip?.status) {
                const commonData = {
                    EndUserIp: userip?.data,
                    TraceId: decryptUrlDatapattern(searchParams.get('tId')),
                    ResultIndex: decryptUrlDatapattern(searchParams.get('rIndex'))?.[isDomRtn],
                    FlightBookingId: getbookingid
                }

                const IsLCCFlight = flightFareQouteData?.[isDomRtn]?.response?.results?.isLCC || false;

                if (IsLCCFlight) {
                    const ticketBookingData = {
                        PreferredCurrency: null,
                        AgentReferenceNo: null,
                        Passengers: passangerDetails,
                        ...commonData
                    }
                    dispatch(loaderActions.start());
                    const ticketBookingLCCDetail = await postUsersData("/customerui/v1/ticketbookinglcc", ticketBookingData);
                    if (ticketBookingLCCDetail?.status) {
                        navigate(`/flight/in-process?${newSearchParams?.toString()}`,
                            {
                                state: {
                                    payment: 'success',
                                    BookingId: location?.state?.BookingId,
                                    ResponseType: razorpayresponsedata?.ResponseType,
                                    PaymentId: razorpayresponsedata?.PaymentId,
                                    flightPNR: ticketBookingLCCDetail?.data?.response?.response?.pnr,
                                    flightBookingId: ticketBookingLCCDetail?.data?.response?.response?.bookingId
                                }
                            })
                        dispatch(loaderActions.end());
                    }
                    else {
                        navigate(`/flight/pending?${newSearchParams?.toString()}`,
                            {
                                state: {
                                    payment: 'pending',
                                    BookingId: location?.state?.BookingId,
                                    ResponseType: 2,
                                    PaymentId: razorpayresponsedata?.PaymentId,
                                    BookingStatus: 7
                                }
                            })

                        dispatch(loaderActions.end());
                    }
                }
                else {
                    const bookDataUpdated = UpdatedBookFlightData(isDomRtn) ? UpdatedBookFlightData(isDomRtn) : bookFlightData;

                    const ticketBookingNonLCCData = {
                        ...commonData,
                        pnr: bookDataUpdated?.response?.response?.pnr,
                        bookingId: bookDataUpdated?.response?.response?.bookingId,
                    }
                    dispatch(loaderActions.start());

                    const ticketBookingNonLCCDetail = await postUsersData("/customerui/v1/ticketbookingnonlcc", ticketBookingNonLCCData);
                    if (ticketBookingNonLCCDetail?.status) {

                        navigate(`/flight/in-process?${newSearchParams?.toString()}`,
                            {
                                state: {
                                    payment: 'success',
                                    BookingId: location?.state?.BookingId,
                                    ResponseType: razorpayresponsedata?.ResponseType,
                                    PaymentId: razorpayresponsedata?.PaymentId,
                                    flightPNR: ticketBookingNonLCCDetail?.data?.response?.response?.pnr,
                                    flightBookingId: ticketBookingNonLCCDetail?.data?.response?.response?.bookingId,
                                }
                            })
                        dispatch(loaderActions.end());

                    }
                    else {
                        navigate(`/flight/pending?${newSearchParams?.toString()}`,
                            {
                                state: {
                                    payment: 'pending',
                                    BookingId: location?.state?.BookingId,
                                    ResponseType: 2,
                                    PaymentId: razorpayresponsedata?.PaymentId,
                                    BookingStatus: 7
                                }
                            })
                        dispatch(loaderActions.end());
                    }
                }
            }
            else {
                dispatch({ type: 'ALERTING', message: APIBadMessage, redirectTo: '/' });
            }
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }

    }
    //#endregion

    //#region check whether user come after clicking on countinue button or not
    useEffect(() => {
        const isContinue = sessionStorage.getItem('isContinue') ? decryptUrlDatapattern(sessionStorage.getItem('isContinue')) : false
        if (!isContinue) {
            // dispatch({ type: 'ALERTING', message: "Please fill all the passenger details" });
            navigate({ pathname: `/flight/review`, search: newSearchParams.toString() }, { state: location?.state })
        }
    }, [passengersData, passengersDetailsData, otherData, othersDetailsData])
    //#endregion

    //#region after open the razor pay gateway when user refresh the page then payment is going to failed.
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        if (localStorage.getItem('isOpen') === `${getbookingid}` && localStorage.getItem('isOpenDup') === "true") {
            const paymentid = Number(localStorage.getItem('temp'))
            const user: any = GetLocalStorage()
            const doc = document.getElementById("Website")
            doc?.parentNode?.removeChild(doc);

            const isSkip = localStorage.getItem('skip') ? decryptUrlDatapattern(localStorage.getItem('skip')) : false
            rezorPayClose(paymentid, user?.userMasterID, JSON.parse(isSkip))
        }
        else {
            if (location?.state?.isRetryPayment) {
                const user: any = GetLocalStorage();
                const bookingParameter = {
                    BookingId: getbookingid,
                    UserId: user?.userMasterID
                }
                callPaymentGateway(bookingParameter, location?.state?.isSkipToPay, location?.state?.isRetryPayment);
            }
        }

        if (localStorage.getItem('isOpen') === `${getbookingid}`) {
            window.history.forward();
        }
    }, [location?.state?.isRetryPayment])
    //#endregion

    const validateData = () => {
        let status = true;
        if ((requiredFieldValidators?.isMealRequired && !selectedSeatMealDynamicValidation?.mealcheck) && (requiredFieldValidators?.isSeatRequired && !selectedSeatMealDynamicValidation?.seatcheck)) {
            dispatch({ type: 'ALERTING', message: 'Please select seat & meal to proceed for booking.' });
            status = false;
        }
        else if (requiredFieldValidators?.isSeatRequired && !selectedSeatMealDynamicValidation?.seatcheck) {
            dispatch({ type: 'ALERTING', message: 'Please select seat.' });
            status = false;
        }
        else if (requiredFieldValidators?.isMealRequired && !selectedSeatMealDynamicValidation?.mealcheck) {
            dispatch({ type: 'ALERTING', message: 'Please select meal.' });
            status = false;
        }
        return status;
    }

    //#region after click on countinue or skip to pay button and insert the travelers data get the razorpay's neccessory data from database(api) and checkout the razor pay
    const handleCheckoutRazorPay = async (isSkipToPay: boolean) => {
        if (validateData()) {
            localStorage.setItem('skip', encryptUrlDatapattern(isSkipToPay))
            dispatch(loaderActions.start())
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user: any = GetLocalStorage();
                // const queryObject = Object?.fromEntries(searchParams?.entries());
                if (getbookingid > 0) {
                    let travellerBookingData: any = {
                        flightBookingId: getbookingid || 0,
                        baseFare: getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.baseFare,
                        tax: getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.totalTaxAndSurcharges,
                        ConvinienceFee: (convenienceData?.convinienceFeeCharged ? Math.round(convenienceData?.convinienceFeeCharged) : 0),
                        Markup: getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.markupCharges,
                        GSTAmount: getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.gstCharges,
                        userId: user?.userMasterID || 0
                    }
                    if (isSkipToPay) {
                        travellerBookingData = {
                            ...travellerBookingData,
                            finalValue: (
                                (getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.grandTotal)
                                + (convenienceData?.convinienceFeeCharged ? Math.round(convenienceData?.convinienceFeeCharged) : 0))
                                || 0,
                        }
                    }
                    else {
                        travellerBookingData = {
                            ...travellerBookingData,
                            finalValue: ((getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.grandTotal) + (selectedBaggageTotalPrice ? selectedBaggageTotalPrice : 0) + (selectedMealDynamicTotalPrice ? selectedMealDynamicTotalPrice : 0) + (selectedSeatTotalPrice ? selectedSeatTotalPrice : 0) + (convenienceData?.convinienceFeeCharged ? Math.round(convenienceData?.convinienceFeeCharged) : 0)) || 0,
                            TotalBaggageCharges: (selectedBaggageTotalPrice ? selectedBaggageTotalPrice : 0),
                            TotalMealCharges: (selectedMealDynamicTotalPrice ? selectedMealDynamicTotalPrice : 0),
                            TotalSeatCharges: (selectedSeatTotalPrice ? selectedSeatTotalPrice : 0),
                        }
                    }
                    const insertflighttravellerbooking = await postUsersData('/customerui/v1/insertflighttravellerbooking', travellerBookingData);
                    if (insertflighttravellerbooking?.status) {
                        const bookingParameter = {
                            BookingId: getbookingid,
                            UserId: user?.userMasterID
                        }
                        callPaymentGateway(bookingParameter, isSkipToPay, false)
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: insertflighttravellerbooking?.message || APIBadMessage, redirectTo: '/' });
                        dispatch(loaderActions.end());
                    }
                }
            }
            else {
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end())
            }
        }
    }
    //#endregion

    const callPaymentGateway = async (bookingParameter: any, isSkipToPay: boolean, isRetryPayment: any) => {
        await postUsersData('/customerui/v1/getflightbookingparameter', bookingParameter).then(async (res) => {
            if (res?.status) {
                localStorage.setItem("temp", res?.data[0]?.PaymentId)
                localStorage.setItem("last", "false")
                if (document?.getElementsByTagName("body")?.[0]?.classList?.contains("overflow-auto")) {
                    document?.getElementsByTagName("body")?.[0]?.classList?.remove("overflow-auto")
                }
                if (isRetryPayment === false && flightFareQouteData?.[isDomRtn]?.response?.results?.isLCC === false) {
                    let userip = await fetchIp();
                    if (userip?.status) {

                        const passangerDetails = getPassangersData(isSkipToPay);

                        const bookingData = {
                            EndUserIp: userip?.data,
                            TraceId: decryptUrlDatapattern(searchParams.get('tId')),
                            ResultIndex: decryptUrlDatapattern(searchParams.get('rIndex'))?.[isDomRtn],
                            FlightBookingId: getbookingid,
                            Passengers: passangerDetails
                        }

                        const bookingflightsDetail = await postUsersData("/customerui/v1/bookingflights", bookingData);
                        if (bookingflightsDetail?.status) {
                            const bookFlightData = bookingflightsDetail?.data || null;

                            const isPriceChanged = bookingflightsDetail?.data?.response?.response?.isPriceChanged || false;
                            const isTimeChanged = bookingflightsDetail?.data?.response?.response?.isTimeChanged || false;

                            if (isPriceChanged || isTimeChanged) {
                                if (typeof onFlightDataUpdate === 'function') {
                                    onFlightDataUpdate();
                                }
                                setShowPriceTimeUpdatedModal(true);
                            }
                            else {
                                localStorage.setItem('isOpen', `${getbookingid}`);
                                localStorage.setItem('isOpenDup', 'true');
                                checkoutjs(res?.data?.[0], true, isSkipToPay, bookFlightData);
                            }
                            dispatch(loaderActions.end());
                        }
                        else {
                            navigate(`/flight/pending?${newSearchParams?.toString()}`,
                                {
                                    state: {
                                        payment: 'pending',
                                        BookingId: location?.state?.BookingId,
                                        ResponseType: 2,
                                        PaymentId: res?.data[0]?.PaymentId,
                                        BookingStatus: 7
                                    }
                                })
                            dispatch(loaderActions.end());
                        }
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: APIBadMessage, redirectTo: '/' });
                    }
                }
                else {
                    localStorage.setItem('isOpen', `${getbookingid}`)
                    localStorage.setItem('isOpenDup', 'true')
                    checkoutjs(res?.data?.[0], true, isSkipToPay, null);
                }
            }
            else {
                dispatch({ type: 'ALERTING', message: APIBadMessage, redirectTo: '/' });
                dispatch(loaderActions.end());
            }
        })
    }

    //#region checkout razorpay along with add the razorpay's script
    const checkoutjs = (data: any, isScript: any, isSkipToPay: boolean, bookFlightData: any) => {
        if (isScript) {
            const script = document.createElement('script');
            script.src = data?.Website;
            script.async = true;
            script.id = "Website";
            script.onload = (e) => paymentCheckout(e, data, isSkipToPay, bookFlightData);
            document?.body?.appendChild(script);
        }
        else {
            let doc = document?.getElementById("Website")
            doc?.parentNode?.removeChild(doc);
        }
    }
    //#endregion

    //#region open the razor pay portal and handle the success and failed response
    const paymentCheckout = async (e: any, data: any, isSkipToPay: boolean, bookFlightData: any) => {
        const user: any = GetLocalStorage();
        const options = {
            key: data?.MerchantId, // Enter the Key ID generated from the Dashboard
            amount: data?.BookingAmount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: data?.Currency,
            name: data?.BookingTitle, //your business name
            order_id: data?.OrderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            image: require("../../../../assets/img/etm-logo1.png"),
            // "callback_url": "http://localhost:4000/api/callback",
            handler: async function (response: any) {
                let razorpayresponsedata = {
                    PaymentId: data?.PaymentId,
                    ResponseType: 1,
                    key_id: data?.MerchantId,
                    key_secret: data?.MerchantKey,
                    razorpay_payment_id: response?.razorpay_payment_id,
                    razorpay_order_id: response?.razorpay_order_id,
                    razorpay_signature: response?.razorpay_signature,
                    UserId: user?.userMasterID
                }
                rezorPayResponse(razorpayresponsedata, data, e, isSkipToPay, bookFlightData)
            },
            prefill: { //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
                name: `${leadPassengerData?.FirstName} ${leadPassengerData?.LastName}` || "", //your customer's name
                email: leadPassengerData?.Email || "", //your customer's email
                contact: leadPassengerData?.ContactNo || ""  //Provide the customer's phone number for better conversion rates 
            },
            notes: {
                // address: "Razorpay Corporate Office"
                address: `${leadPassengerData?.AddressLine1}${leadPassengerData?.AddressLine2 ? ' ' + leadPassengerData?.AddressLine2 : ''}` || "",
                GSTNumber: leadPassengerData?.GSTNumber || "",
                GSTCompanyName: leadPassengerData?.GSTCompanyName || "",
                GSTCompanyEmail: leadPassengerData?.GSTCompanyEmail || "",
                GSTCompanyContactNumber: leadPassengerData?.GSTCompanyContactNumber || "",
                GSTCompanyAddress: leadPassengerData?.GSTCompanyAddress || "",
            },
            theme: {
                color: "#3399cc"
            },
            modal: {
                ondismiss: function (response: any) {
                    checkoutjs(data, false, isSkipToPay, bookFlightData)
                    if (localStorage.getItem('isOpen') === `${getbookingid}` && localStorage.getItem('isOpenDup') === "true") {
                        for (let i = 0; i < razorpopup?.length; i++) {
                            razorpopup?.[i]?.parentNode?.removeChild(razorpopup?.[i]);
                        }
                    }
                    rezorPayClose(data?.PaymentId, user?.userMasterID, isSkipToPay, bookFlightData);
                }
            }
        };
        const rzp = new (window as any).Razorpay(options)
        rzp.open();
        e.preventDefault();
        localStorage.setItem('isOpenDup', 'true')


        rzp.on('payment.failed', function (response: any) {

            let razorpayresponsedata = {
                PaymentId: data?.PaymentId,
                ResponseType: 0,
                key_id: data?.MerchantId,
                key_secret: data?.MerchantKey,
                razorpay_payment_id: response?.error?.metadata?.payment_id,
                razorpay_order_id: response?.error?.metadata?.order_id,
                razorpay_signature: "",
                UserId: user?.userMasterID
            }
            rezorPayResponse(razorpayresponsedata, data, e, isSkipToPay, bookFlightData);
        });
        dispatch(loaderActions.end())
    }
    //#endregion

    //#region call api for insert the razorpay response in the database
    const rezorPayResponse = async (razorpayresponsedata: any, data: any, e: any, isSkipToPay: boolean, bookFlightData: any) => {
        for (let i = 0; i < razorpopup?.length; i++) {
            razorpopup?.[i]?.parentNode?.removeChild(razorpopup?.[i]);
        }
        document?.getElementsByTagName("body")?.[0]?.classList?.add("overflow-auto")

        dispatch(loaderActions.start())
        const paymentResponse = await postUsersData('/customerui/v1/flightrazorpayresponse', razorpayresponsedata)
        if (paymentResponse?.status) {
            checkoutjs(data, false, isSkipToPay, bookFlightData)
            // navigate(`/flight/${razorpayresponsedata?.ResponseType === 1 ? 'in-process' : 'failed'}?${newSearchParams?.toString()}`,
            //     {
            //         state: {
            //             payment: razorpayresponsedata?.ResponseType === 1 ? 'success' : 'failed',
            //             BookingId: location?.state?.BookingId, ResponseType: razorpayresponsedata?.ResponseType,
            //             PaymentId: data?.PaymentId
            //         }
            //     })

            // dispatch(loaderActions.end());
            if (razorpayresponsedata?.ResponseType === 1) {
                const Passenger = getPassangersData(isSkipToPay);

                bookingLCCnonLCCFlight(Passenger, razorpayresponsedata, isSkipToPay, bookFlightData);
            }
            else {
                navigate(`/flight/failed?${newSearchParams?.toString()}`,
                    {
                        state: {
                            payment: 'failed',
                            BookingId: location?.state?.BookingId,
                            mealDynamicCollection: mealDynamicCollection,
                            ResponseType: razorpayresponsedata?.ResponseType,
                            leadPassengerData: leadPassengerData,
                            flightFareQouteData: flightFareQouteData,
                            PaymentId: data?.PaymentId,
                            isSkipToPay: isSkipToPay
                        }
                    })
                dispatch(loaderActions.end());
            }
        }
        else {
            dispatch({ type: 'ALERTING', message: APIBadMessage, redirectTo: '/' })
            dispatch(loaderActions.end());
        }
    }

    const rezorPayClose = async (paymentid: any = null, userId: any = null, isSkipToPay: any = null, bookFlightData: any = null) => {
        for (let i = 0; i < razorpopup?.length; i++) {
            razorpopup?.[i]?.parentNode?.removeChild(razorpopup?.[i]);
        }
        document?.getElementsByTagName("body")?.[0]?.classList?.add("overflow-auto")

        dispatch(loaderActions.start())
        let closedata = {
            PaymentId: paymentid,
            UserId: userId
        }
        const closeResponse = await postUsersData('/customerui/v1/getflightrazorpayclose', closedata)
        if (closeResponse?.status) {
            navigate(`/flight/failed?${newSearchParams?.toString()}`,
                {
                    state: {
                        payment: 'failed',
                        BookingId: location?.state?.BookingId,
                        mealDynamicCollection: mealDynamicCollection,
                        leadPassengerData: leadPassengerData,
                        flightFareQouteData: flightFareQouteData,
                        ResponseType: 0,
                        PaymentId: paymentid,
                        isSkipToPay: isSkipToPay,
                        isRetryPayment: false
                    }
                })
        }
        else {
            dispatch({ type: 'ALERTING', message: APIBadMessage, redirectTo: '/' })
        }
        dispatch(loaderActions.end())
    }
    //#endregion

    //#region Select Meal and Baggage
    const handleSelectMealBaggage = (type: string, flightNumber: string, paxType: any, id: any, item: any) => {
        let selectedItem = JSON.parse(item)
        if (type === 'Meal') {
            setMealDynamicCollection(
                mealDynamicCollection?.map((obj: any) => {
                    if (obj?.flightNumber === selectedItem?.flightNumber && obj?.IsMealValidate !== true && obj?.paxType?.length > 0 && (obj?.paxType?.includes(`${paxType}${id}`))) {
                        obj.paxType = obj?.paxType?.filter((item: any) => item !== `${paxType}${id}`);
                        obj.IsMealSelected = false;
                    }
                    if (obj?.flightNumber === flightNumber && selectedItem === 0 && obj?.IsMealValidate !== true) {
                        obj.paxType = obj?.paxType?.filter((item: any) => item !== `${paxType}${id}`);
                        obj.IsMealSelected = false;
                    }
                    else {
                        if (obj?.flightNumber === selectedItem?.flightNumber && obj?.code === selectedItem?.code && obj?.airlineDescription === selectedItem?.airlineDescription) {
                            if (obj?.IsMealValidate !== true) {
                                obj.paxType = [...obj?.paxType, `${paxType}${id}`];
                            }
                            obj.IsMealSelected = true;
                        }
                        else {
                            obj.IsMealSelected = false;
                        }
                    }
                    return obj;
                }));
        }
        else {
            setBaggageCollection(
                baggageCollection?.map((obj: any) => {
                    if (obj?.flightNumber === selectedItem?.flightNumber && obj?.IsBaggageValidate !== true && obj?.paxType?.length > 0 && (obj?.paxType?.includes(`${paxType}${id}`))) {
                        obj.paxType = obj?.paxType?.filter((item: any) => item !== `${paxType}${id}`);
                        obj.IsBagageSelected = false;
                    }

                    if (obj?.flightNumber === flightNumber && selectedItem === 0 && obj?.IsBaggageValidate !== true) {
                        obj.paxType = obj?.paxType?.filter((item: any) => item !== `${paxType}${id}`);
                        obj.IsBagageSelected = false;
                    }
                    else {
                        if (obj?.flightNumber === selectedItem?.flightNumber && obj?.code === selectedItem?.code && obj?.weight === selectedItem?.weight && obj?.price === selectedItem?.price) {
                            if (obj?.IsBaggageValidate !== true) {
                                obj.paxType = [...obj?.paxType, `${paxType}${id}`];
                            }
                            obj.IsBagageSelected = true;
                        }
                        else {
                            obj.IsBagageSelected = false;
                        }
                    }
                    return obj;
                }));
        }
    }
    //#endregion

    return (
        <div className="row" onClick={() => { setIsMealDropdownOpen(false); setIsBaggageDropdownOpen(false) }} >
            <div className="detailContainer">
                {
                    flightFareQouteData?.[isDomRtn] && (
                        <FlightReviewComponant
                            isDomRtn={isDomRtn}
                            flightData={flightFareQouteData}
                            flightFareRuleData={flightFareRuleData}
                            UpdatedBookFlightData={UpdatedBookFlightData}
                        />
                    )
                }

                <div className="features">
                    <div className="flightNav">
                        <ul className="nav nav-tabs overflow-auto pb-1" id="myTab" role="tablist">
                            {flightCollection?.map((flight, flightIndex) => (
                                <li className="nav-item" role="presentation" key={`${flight?.flightNumber}${flightIndex + 1}`}>
                                    <button
                                        className={`nav-link ${selectedFlight === `flight${flightIndex + 1}${flight?.flightNumber}` ? 'active' : ''}`}
                                        id={`flight${flightIndex + 1}${flight?.flightNumber}tab`}
                                        data-bs-toggle="tab"
                                        data-bs-target={`#flight${flightIndex + 1}${flight?.flightNumber}`}
                                        type="button" role="tab"
                                        aria-controls={`flight${flightIndex + 1}${flight?.flightNumber}tab`}
                                        aria-selected={selectedFlight === `flight${flightIndex + 1}${flight?.flightNumber}` ? true : false}
                                        onClick={() => handleChangeFlight(flight, flightIndex)}
                                    >
                                        <img src={flightIcon} alt="" />
                                        Flight {flightIndex + 1} <br />{flight?.flightName}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="detailDiv pt-3">
                        <div className="tab-content" id="myTabContent">
                            {
                                flightCollection?.map((flight, flightIndex) => (
                                    <div
                                        className={`tab-pane fade ${selectedFlight === `flight${flightIndex + 1}${flight?.flightNumber}` ? 'active show' : ''}`}
                                        id={`flight${flightIndex + 1}${flight?.flightNumber}`}
                                        role="tabpanel"
                                        aria-labelledby={`flight${flightIndex + 1}${flight?.flightNumber}tab`}
                                        key={`flight${flightIndex + 1}${flight?.flightNumber}key`}
                                    >

                                        <div className="personNav">
                                            <ul className="nav nav-tabs overflow-auto pb-1" id="myTab" role="tablist">
                                                {
                                                    passengersDetailsData?.filter((fil: any) => fil?.PaxType !== 3)?.map((pass: any, passIndex: any) => (

                                                        <li className="nav-item" role="presentation" key={`${getPassengerType(pass?.PaxType)}${pass?.id}${passIndex + 1}`} >
                                                            <button
                                                                className={`nav-link ${selectedFlightPassenger === `flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}` ? 'active' : ''} `}
                                                                id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${passIndex + 1}`}
                                                                data-bs-toggle="tab"
                                                                data-bs-target={`#flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}`}
                                                                type="button" role="tab"
                                                                aria-controls={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}`}
                                                                aria-selected={selectedFlightPassenger === `flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}` ? true : false}
                                                                onClick={() => handleChangeFlightPassenger(flight, flightIndex, pass)}
                                                            >
                                                                {getPassengerType(pass?.PaxType)} {pass?.id}
                                                            </button>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>

                                        <div className="personDetailDiv pt-2">
                                            <div className="tab-content" id="myTabContent">

                                                {
                                                    passengersDetailsData?.filter((fil: any) => fil?.PaxType !== 3)?.map((pass: any, passIndex: any) => (
                                                        <div
                                                            className={`tab-pane fade ${selectedFlightPassenger === `flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}` ? 'active show' : ''}`}
                                                            id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}`}
                                                            role="tabpanel"
                                                            aria-labelledby={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${passIndex + 1}`}
                                                            key={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${passIndex + 1}key`}
                                                        >
                                                            {/* <!--seat meal and baggage --> */}
                                                            <div className="seatNav">
                                                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                                                    <li className="nav-item" role="presentation">
                                                                        <button
                                                                            className="nav-link active"
                                                                            id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${passIndex + 1}Seat`}
                                                                            data-bs-toggle="tab"
                                                                            data-bs-target={`#flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}Seat`}
                                                                            type="button" role="tab"
                                                                            aria-controls={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}Seat`}
                                                                            aria-selected="false"
                                                                        >
                                                                            <img src={require("../../../../assets/img/flights/Icone/icon-seat.png")} alt="icon seat" /> Seat
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item" role="presentation">
                                                                        <button
                                                                            className="nav-link"
                                                                            id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${passIndex + 1}Meal`}
                                                                            data-bs-toggle="tab"
                                                                            data-bs-target={`#flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}Meal`}
                                                                            type="button" role="tab"
                                                                            aria-controls={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}Meal`}
                                                                            aria-selected="false"
                                                                        >
                                                                            <img src={require("../../../../assets/img/flights/Icone/icon-food.png")} alt="icon food" /> Meal
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item" role="presentation">
                                                                        <button
                                                                            className="nav-link"
                                                                            id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${passIndex + 1}Baggage`}
                                                                            data-bs-toggle="tab"
                                                                            data-bs-target={`#flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}Baggage`}
                                                                            type="button" role="tab"
                                                                            aria-controls={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}Baggage`}
                                                                            aria-selected="false"
                                                                        >
                                                                            <img src={require("../../../../assets/img/flights/Icone/icon-baggage.png")} alt="icon baggage" /> Baggage
                                                                        </button>
                                                                    </li>
                                                                </ul>

                                                                <button type='button' className="btn p-0 skiptoPay" disabled={location?.state?.isRetryPayment} onClick={() => handleCheckoutRazorPay((requiredFieldValidators?.isMealRequired || requiredFieldValidators?.isSeatRequired) ? false : true)} ><i className="fa-solid fa-money-bill-transfer"></i> <span>Skip to Pay</span></button>
                                                            </div>

                                                            <div className="detailDiv pt-3">
                                                                <div className="tab-content" id="myTabContent">
                                                                    <div
                                                                        className="tab-pane fade active show"
                                                                        id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}Seat`}
                                                                        role="tabpanel"
                                                                        aria-labelledby={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${passIndex + 1}Seat`}
                                                                        key={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}SeatKey`}
                                                                    >
                                                                        <div className="mealAndBags seatsDesign">
                                                                            <SeatBooking
                                                                                seatDynamicCollection={seatDynamicCollection}
                                                                                setSeatDynamicCollection={setSeatDynamicCollection}
                                                                                flight={flight}
                                                                                flightIndex={flightIndex}
                                                                                pass={pass}
                                                                            />
                                                                        </div>

                                                                    </div>

                                                                    <div
                                                                        className="tab-pane fade"
                                                                        id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}Meal`}
                                                                        role="tabpanel"
                                                                        aria-labelledby={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${passIndex + 1}Meal`}
                                                                        key={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}MealKey`}
                                                                    >

                                                                        <div className="height200">
                                                                            <div className="row">
                                                                                <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12 pr">

                                                                                    <div className="form-floating searching">
                                                                                        <select
                                                                                            className="form-select"
                                                                                            id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}mealsdropdown`}
                                                                                            value={
                                                                                                JSON.stringify(mealDynamicCollection?.find((fil: any) => fil?.flightNumber === flight?.flightNumber && fil?.airlineDescription && fil?.IsMealSelected === true && fil?.paxType?.length > 0 && fil?.paxType?.includes(`${pass?.PaxType}${pass?.id}`)))
                                                                                                || 0
                                                                                            }
                                                                                            onChange={(e) => { handleSelectMealBaggage('Meal', flight?.flightNumber, pass?.PaxType, pass?.id, e.target.value) }}
                                                                                        >
                                                                                            <option value={0} > Select Meal </option>
                                                                                            {
                                                                                                mealDynamicCollection?.length > 0 && mealDynamicCollection?.filter((fil: any) => fil?.airlineDescription && fil?.flightNumber === flight?.flightNumber)?.length > 0 && mealDynamicCollection?.filter((fil: any) => fil?.airlineDescription && fil?.flightNumber === flight?.flightNumber)?.map((meals: any, mealIndex: any) => {
                                                                                                    return (
                                                                                                        <option
                                                                                                            key={`meal${mealIndex}`}
                                                                                                            value={JSON.stringify(meals)} >
                                                                                                            {`${meals?.airlineDescription} ₹${meals?.price}`}
                                                                                                        </option>
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </select>
                                                                                        <label htmlFor={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}mealsdropdown`}>
                                                                                            Select Meal
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                    <div
                                                                        className="tab-pane fade"
                                                                        id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}Baggage`}
                                                                        role="tabpanel"
                                                                        aria-labelledby={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${passIndex + 1}Baggage`}
                                                                        key={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}BaggageKey`}
                                                                    >
                                                                        <div className="height200">
                                                                            <div className="row">
                                                                                <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12 pr">

                                                                                    <div className="form-floating searching">
                                                                                        <select
                                                                                            className="form-select"
                                                                                            id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}baggagedropdown`}
                                                                                            value={
                                                                                                JSON.stringify(baggageCollection?.find((fil: any) => fil?.flightNumber === flight?.flightNumber && fil?.IsBagageSelected === true && fil?.paxType?.length > 0 && fil?.paxType?.includes(`${pass?.PaxType}${pass?.id}`)))
                                                                                                || 0
                                                                                            }
                                                                                            onChange={(e) => { handleSelectMealBaggage('Baggage', flight?.flightNumber, pass?.PaxType, pass?.id, e.target.value) }}
                                                                                        >
                                                                                            <option value={0} > Select Baggage </option>
                                                                                            {
                                                                                                baggageCollection?.filter((fil: any) => fil?.weight && fil?.flightNumber === flight?.flightNumber).length > 0 && baggageCollection?.filter((fil: any) => fil?.weight && fil?.flightNumber === flight?.flightNumber)?.map((bag: any, bagIndex: any) => {
                                                                                                    return (
                                                                                                        <option
                                                                                                            key={`bag${bagIndex}`}
                                                                                                            value={JSON.stringify(bag)} >
                                                                                                            {`${bag?.weight}-Kg ₹${bag?.price}`}
                                                                                                        </option>
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </select>
                                                                                        <label htmlFor={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}baggagedropdown`}>
                                                                                            Select Baggage
                                                                                        </label>
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                            {/* <!--seat meal and baggage --> */}
                                                        </div>
                                                    ))
                                                }


                                            </div>
                                        </div>

                                    </div>
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>


            <Modal
                show={showPriceTimeUpdatedModal}
                onHide={() => setShowPriceTimeUpdatedModal(false)}
                dialogClassName="modal-90w"
                size="lg"
                backdrop="static"
                aria-labelledby="flight-price-time-updated"
                centered
            >
                <Modal.Body>
                    <center>
                        <div className="my-3">
                            <strong>
                                {messagePriceTimeUpdate}
                            </strong>
                        </div>
                        <button
                            type="button"
                            className="btn continueBtn"
                            onClick={() => setShowPriceTimeUpdatedModal(false)}
                        >
                            OK
                        </button>
                    </center>
                </Modal.Body>
            </Modal>

            <div className="rightSec">
                <div className="holidayPriceSummary">
                    <PriceSummary
                        adultPrice={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 1)?.baseFare}
                        adultCount={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 1)?.passengerCount}
                        childPrice={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 2)?.baseFare}
                        childCount={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 2)?.passengerCount}
                        infantPrice={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 3)?.baseFare}
                        infantCount={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 3)?.passengerCount}
                        taxValue={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.totalTaxAndSurcharges}
                        otherValue={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.otherCharges}
                        finalValue={(getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.grandTotal) + (selectedBaggageTotalPrice ? selectedBaggageTotalPrice : 0) + (selectedMealDynamicTotalPrice ? selectedMealDynamicTotalPrice : 0) + (selectedSeatTotalPrice ? selectedSeatTotalPrice : 0) + (convenienceData?.convinienceFeeCharged ? convenienceData?.convinienceFeeCharged : 0)}
                        baggageCharges={selectedBaggageTotalPrice}
                        mealCharges={selectedMealDynamicTotalPrice}
                        seatCharges={selectedSeatTotalPrice}
                        convinienceFeeCharged={convenienceData?.convinienceFeeCharged}
                    />
                    <button type='button' className="btn continueBtn" disabled={location?.state?.isRetryPayment} onClick={() => handleCheckoutRazorPay(false)} >Continue</button>
                </div>
            </div>
        </div>
    )
}

export default FlightPayment
